module.exports = __webpack_public_path__ + "img/traffic-img3.db908ed9.png";